import { Box, Card, Typography } from '@material-ui/core'
import { Container, ContentHeader, Page } from 'components'
import { ServiceCategoryForm } from './components'

import useStyles from './styles'

const ServiceCategoriesNew = () => {
  const classes = useStyles()

  return (
    <Page title="Nova categoria de serviço">
      <Container
        maxWidth={false}
        spacingXl={50}
        spacingLg={25}
        spacingMd={10}
        spacingSm={10}
      >
        <ContentHeader
          menu="Gerenciamento"
          title="categoria de serviço"
          subtitle="Nova categoria de serviço"
        />
        <Card>
          <Box p={2} className={classes.borderBottom}>
            <Typography variant="h5">Criar categoria de serviço</Typography>
          </Box>
          <Box mt={3}>
            <ServiceCategoryForm />
          </Box>
        </Card>
      </Container>
    </Page>
  )
}

export default ServiceCategoriesNew
